var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-dot",class:{ pressed: _vm.pressed }},[_c('div',{staticClass:"slider-dot__nub"})])}
var staticRenderFns = []

export { render, staticRenderFns }